export default "__VITE_ASSET__CpQ1ekfW__"